import React from "react";
import { ArrowUpRight } from "lucide-react";
import { NavLink } from "react-router-dom";

const PredictNavFoot = ({ links, iconOnly }) => (
  <footer
    className={`bp-predict-nav-foot${iconOnly ? " bp-predict-nav-foot-collapsed" : ""}`}
    aria-label="Leave desk"
  >
    {!iconOnly ? (
      <div className="bp-predict-nav-foot-head">
        <p className="bp-predict-nav-foot-kicker">Gates</p>
        <span className="bp-predict-nav-foot-hint">Quick exits</span>
      </div>
    ) : null}
    <nav className="bp-predict-nav-foot-wayfinder" aria-label="Desk shortcuts">
      {links.map(({ to, label, Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            `bp-predict-nav-foot-gate${isActive ? " bp-predict-nav-foot-gate-on" : ""}`
          }
          title={label}
        >
          <span className="bp-predict-nav-foot-gate-node">
            <Icon size={iconOnly ? 14 : 13} strokeWidth={2.25} aria-hidden />
          </span>
          {!iconOnly ? (
            <>
              <span className="bp-predict-nav-foot-gate-label">{label}</span>
              <ArrowUpRight size={11} className="bp-predict-nav-foot-gate-arrow" aria-hidden />
            </>
          ) : null}
        </NavLink>
      ))}
    </nav>
  </footer>
);

export default PredictNavFoot;
